<!--
component: BrowseKosakuView
author: Ken Nakamura
description: 築造計画概要書一面
-->
<template>
  <section class="A4 gaiyo">
    <img :src="imageUrl" width="100%" height="100%" v-if="imageUrl"/>
    <!--
    <div v-if="imageUrl" class="A4">
      <img :src="imageUrl" height="100%"/>
    </div>
    -->
    <!--
    <div v-if="imageUrl" class="A4">
      <div v-if="printing">
        <img :src="imageUrl" height="100%"/>
      </div>
      <div v-else>
      <BrowseBuildingImage :fileUrl="imageUrl" />
      </div>
    </div>
    -->
    <div v-else>
    <br>
    <p>第一号様式</p>
    <p class="gaiyo-section-header">
      築造計画概要書（第一面）
    </p>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【１．敷地の位置】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【イ．地名地番】</div>
      <div class="gaiyo-element left-60">
        {{data.timeiTiban}}
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ロ．住居表示】</div>
      <div class="gaiyo-element left-60">
        {{data.jukyoDisp}}
      </div>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【２．擁壁の概要】</div>
    </div>
    <div v-for="(gaiyo, index) in data.gaiyo" :key="`gaiyo-${index}`">
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【イ．高さ】</div>
      <div class="gaiyo-element left-60">{{fmt(gaiyo.height / 1000, 3)}} m</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ロ．工事種別】</div>
      <div class="gaiyo-element left-60">（ {{gaiyo.kojiSybtName}} ）</div>
      <!--<div class="gaiyo-element left-80">{{gaiyo.gaiyo[0].gutaiKojiSybt}}</div>-->
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ハ．新築以外工事種別】</div>
      <div class="gaiyo-element left-60">（ {{gaiyo.kojiEtcSybtName}} ）</div>
      <div class="gaiyo-element left-80">{{gaiyo.gutaiKojiSybt}}</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ニ．構造】</div>
      <div class="gaiyo-element left-60">{{gaiyo.gutaiKozoSybt}}</div>
    </div>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【３．処分の経過】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【確認済証交付年月日・番号】</div>
      <div class="gaiyo-element left-70">
        {{dateTextToWareki(data.shinsei.kknN_DAY)}}
      </div>
      <div class="gaiyo-element left-105">第</div>
      <div class="gaiyo-element left-110">
        {{data.shinsei.kknN_NO}}
      </div>
      <div class="gaiyo-element left-180">号</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【確認済証交付者】</div>
      <div class="gaiyo-element left-70">
        {{data.shinsei.dlvrer}}
      </div>
    </div>
    <div v-for="(henko, index) in data.henko" :key="`henko-${index}`">
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【計画変更確認済証交付年月日・番号】</div>
        <div class="gaiyo-element left-70">
          {{dateTextToWareki(henko.kknN_DAY)}}
        </div>
        <div class="gaiyo-element left-105">第</div>
        <div class="gaiyo-element left-110">
          {{henko.kknN_NO}}
        </div>
        <div class="gaiyo-element left-180">号</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【計画変更確認済証交付者】</div>
        <div class="gaiyo-element left-70">
          {{henko.dlvrer}}
        </div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【検査済証交付年月日・番号】</div>
      <div class="gaiyo-element left-70">
        {{dateTextToWareki(data.kanryo.kknN_DAY)}}
      </div>
      <div class="gaiyo-element left-105">第</div>
      <div class="gaiyo-element left-110">
        {{data.kanryo.kknN_NO}}
      </div>
      <div class="gaiyo-element left-180">号</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【検査済証交付者】</div>
      <div class="gaiyo-element left-70">
        {{data.kanryo.dlvrer}}
      </div>
    </div>
    </div>
  </section>
</template>

<script>
//import BrowseBuildingImage from '../components/building/BrowseBuildingImage.vue'
import { dateTextToWareki } from '../common/utils'
export default {
  components: {
    //BrowseBuildingImage,
  },
  props: {
    data: {
      type: Object,
      //required: true,
      default: null
    },
    imageUrl: {
      type: String,
      default: ''
    },
  },
  computed: {
    printing() {
      return this.$store.state.printing;
    }
  },
  methods: {
    fmt(val, prec) {
      const v = (val == null) ? 0 : val;
      return v.toFixed(prec);
    },
    dateTextToWareki(date) {
      return dateTextToWareki(date);  // from common/utils.js
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/gaiyo.css";
.gaiyo {
  //font-family: 游明朝,"Yu Mincho",YuMincho,"Hiragino Mincho ProN","Hiragino Mincho Pro",HGS明朝E,"MS Mincho";
  //font-weight: 600;
  font-family: 游ゴシック, "Yu Gothic", YuGothic, "MS Gothic";
  font-weight: 500;
  padding: 0 10mm 0 0;
}
@media print {
  .A4 {
    width: 190mm;
    height: 276mm;
    background-color: white;
    page-break-after: always;
  }
  .gaiyo {
    //font-family: 游明朝,"Yu Mincho",YuMincho,"Hiragino Mincho ProN","Hiragino Mincho Pro",HGS明朝E,"MS Mincho";
    //font-weight: 600;
    font-family: "ＭＳ 明朝","MS Mincho",游明朝,"Yu Mincho",YuMincho,"Hiragino Mincho ProN","Hiragino Mincho Pro",HGS明朝E;
    font-weight: 500;
  }
}
//
.item-row {
  font-size: small;
  line-height: 1;
}
//
.gaiyo-section-header {
  font-size: 12pt;
}
.gaiyo-row {
  line-height: 8mm;
}
.gaiyo-major-title {
  font-size: 11pt;
}
.gaiyo-minor-title {
  font-size: 10.5pt;
}
.gaiyo-element {
  font-size: 10.5pt;
}
.left-110 {
  width: 70mm;
}
.left-180 {
  width: 10mm;
}
/*
.left-40 {
  width: 110mm;
}
.left-50 {
  width: 100mm;
}
.left-60 {
  width: 90mm;
}
.left-100 {
  width: 60mm;
}
.left-130 {
  width: 30mm;
}
*/

</style>